/**
 * App-level auth helpers for protected routes and launcher.
 * Uses existing tokenStorage and config/apps for user and access.
 */

import { getStoredUser } from '../utils/tokenStorage';
import { appsCatalog, canAccessApp } from '../config/apps';

export function getUser() {
  return getStoredUser();
}

export function isLoggedIn() {
  return !!getUser();
}

/**
 * App IDs the current user is allowed to access (for launcher and AppLayout).
 */
export function getAssignedAppIds() {
  const user = getUser();
  if (!user) return [];
  return appsCatalog
    .filter((app) => canAccessApp(user, app))
    .map((app) => app.id);
}
